'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoCircuitBoard = function GoCircuitBoard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 10c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m25 20c0 4.1-3.4 7.5-7.5 7.5h-17.5l7.5-7.5h3.2c0.8 1.5 2.5 2.5 4.3 2.5 2.8 0 5-2.2 5-5s-2.2-5-5-5c-1.9 0-3.5 1-4.3 2.5h-5.7l-11.4 11.4c-2.2-1.3-3.6-3.7-3.6-6.4v-20c0-4.1 3.4-7.5 7.5-7.5v5.7c-1.5 0.8-2.5 2.5-2.5 4.3 0 2.8 2.2 5 5 5 1.8 0 3.5-1 4.3-2.5l6.4 0c0.8 1.5 2.5 2.5 4.3 2.5 2.8 0 5-2.2 5-5s-2.2-5-5-5c-1.9 0-3.5 1-4.3 2.5l-6.4 0c-0.4-0.8-1-1.4-1.8-1.8v-5.7h15c4.1 0 7.5 3.4 7.5 7.5v20z m-12.5-2.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5z m0-15c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5z' })
        )
    );
};

exports.default = GoCircuitBoard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/circuit-board.js
// module id = 1677
// module chunks = 0